export const typeofbacteria_qpt = {
    core_bacteria: [
        'Akkermansia muciniphila',
        'Alistipes putredinis',
        'Bacteroidetes phylum',
        'Bacteroides genus',
        'Bacteroides fragilis',
        'Faecalibacterium prausnitzii',
        'Roseburia hominis'
    ],
    harmful_bacteria: [
        'Bacillus genus',
        'Candida albicans',
        'Clostridium difficile',
        'Escherichia coli',
        'Staphylococcus aureus'
    ],
    beneficial_bacteria: [
        'Bifidobacterium bifidum',
        'Bifidobacterium breve',
        'Bifidobacterium lactis',
        'Bifidobacterium longum',
        'Lactobacillus acidophilus',
        'Lactobacillus gasseri',
        'Lactobacillus helveticus',
        'Lactobacillus paracasei',
        'Lactobacillus plantarum',
        'Lactobacillus reuteri',
        'Lactobacillus rhamnosus',
        'Streptococcus thermophilus'
    ],
}

export const typeofbacteria_qptsm = {
    core_bacteria: [
        'A. muciniphila',
        'A. putredinis',
        'B. genus',
        'B. fragilis',
        'F. prausnitzii',
        'R. hominis'
    ],
    harmful_bacteria: [
        'B. genus',
        'C. albicans',
        'C. difficile',
        'E. coli',
        'S. aureus'
    ],
    beneficial_bacteria: [
        'B. bifidum',
        'B. breve',
        'B. lactis',
        'B. longum',
        'L. acidophilus',
        'L. gasseri',
        'L. helveticus',
        'L. paracasei',
        'L. plantarum',
        'L. reuteri',
        'L. rhamnosus',
        'S. thermophilus'
    ],
}

export const scoreConfig_AllergyandEczema = [
    {
        // Asthma page 1ุ6
        titel: `Asthma`,
        match_key: 'Asthma',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 880,
        Xtextpos: 642,
        Ytextpos: 888,
        formula: 'static_asthma_score',
        page: 16,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Asthma page 13
        titel: `Asthma`,
        match_key: 'Asthma',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 166,
        Xtextpos: 642,
        Ytextpos: 173,
        formula: 'static_asthma_score',
        page: 18,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus plantarum',
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 100, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food allergy page 12
        titel: `Food allergy`,
        match_key: 'Food allergy',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 1031,
        Xtextpos: 642,
        Ytextpos: 1037,
        formula: 'static_asthma_score',
        page: 16,
        value_use: [
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
            'Streptococcus thermophilus'

          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food allergy page 14
        titel: `Food allergy`,
        match_key: 'Food allergy',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 166,
        Xtextpos: 642,
        Ytextpos: 173,
        formula: 'static_asthma_score',
        page: 20,
        value_use: [
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Bacteroides fragilis',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus plantarum',
            'Streptococcus thermophilus'

          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food Eczema page 12
        titel: `Eczema`,
        match_key: 'Eczema',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 955,
        Xtextpos: 642,
        Ytextpos: 960,
        formula: 'static_asthma_score',
        page: 16,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food Eczema page 15
        titel: `Eczema`,
        match_key: 'Eczema',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 166,
        Xtextpos: 642,
        Ytextpos: 173,
        formula: 'static_asthma_score',
        page: 19,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Lactobacillus acidophilus',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food Allergic rhinitis page 12
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 805,
        Xtextpos: 642,
        Ytextpos: 812,
        formula: 'static_asthma_score',
        page: 16,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Food Allergic rhinitis page 12
        titel: `Allergic rhinitis`,
        match_key: 'Allergic rhinitis',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 166,
        Xtextpos: 642,
        Ytextpos: 173,
        formula: 'static_asthma_score',
        page: 17,
        value_use: [
            'Bifidobacterium breve',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    // {
    //     // Food Allergic rhinitis page 16
    //     titel: `Allergic rhinitis`,
    //     match_key: 'Allergic rhinitis',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 250,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 16,
    //     value_use: [
    //         'Bifidobacterium breve',
    //         'Bifidobacterium lactis',
    //         'Bifidobacterium longum',
    //         'Lactobacillus acidophilus',
    //         'Lactobacillus paracasei',
    //         'Lactobacillus plantarum'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#fae01f', label: 'Low'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
    //     ]
    // },
    {
        // Overweight page 18
        titel: `Overweight`,
        match_key: 'Overweight',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 25,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Metabolic syndrome page 18
        titel: ['Metabolic', 'syndrome'],
        match_key: 'Metabolic syndrome',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 110,
        Xtextpos: 642,
        Ytextpos: 118,
        formula: 'static_asthma_score',
        page: 22,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Metabolic syndrome page 20
        titel: `['Metabolic', 'syndrome']`,
        match_key: 'Metabolic syndrome',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 23,
        value_use: [
            'Akkermansia muciniphila',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium lactis',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Type 2 diabetes page 18
        titel: `['Type 2', 'diabetes']`,
        match_key: 'Type 2 diabetes',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 27,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroides fragilis',
            'Faecalibacterium prausnitzii',
            'Bacillus genus',
            'Candida albicans',
            ' Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Type 2 diabetes
        titel: `['Type 2', 'diabetes']`,
        match_key: 'Type 2 diabetes',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 337,
        Xtextpos: 642,
        Ytextpos: 344,
        formula: 'static_asthma_score',
        page: 22,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroides fragilis',
            'Faecalibacterium prausnitzii',
            'Bacillus genus',
            'Candida albicans',
            ' Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Excessive lipopolysaccharide page 18
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 24,
        value_use: [
            'Akkermansia muciniphila',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Excessive lipopolysaccharide page 22
        titel: `['Excessive', 'lipopolysaccharide']`,
        match_key: 'Excessive lipopolysaccharide',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 185,
        Xtextpos: 642,
        Ytextpos: 192,
        formula: 'static_asthma_score',
        page: 22,
        value_use: [
            'Akkermansia muciniphila',
            'Bifidobacterium bifidum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Excessive lipopolysaccharide page 19
        titel: `Overweight`,
        match_key: 'Overweight',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 260,
        Xtextpos: 642,
        Ytextpos: 267,
        formula: 'static_asthma_score',
        page: 22,
        value_use: [
            'Akkermansia muciniphila',
            'Bacteroidetes phylum',
            'Bacteroides genus',
            'Faecalibacterium prausnitzii',
            'Bifidobacterium bifidum',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Constipation page 23
        titel: `Constipation`,
        match_key: 'Constipation',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 110,
        Xtextpos: 642,
        Ytextpos: 118,
        formula: 'static_asthma_score',
        page: 30,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Staphylococcus aureus',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Constipation page 23
        titel: `Constipation`,
        match_key: 'Constipation',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 423,
        Xtextpos: 642,
        Ytextpos: 430,
        formula: 'static_asthma_score',
        page: 30,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Staphylococcus aureus',
            'Bifidobacterium lactis',
            'Bifidobacterium longum',
            'Lactobacillus acidophilus',
            'Lactobacillus paracasei',
            'Lactobacillus plantarum',
            'Lactobacillus rhamnosus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    // {
    //     // Constipation page 23
    //     titel: `Constipation`,
    //     match_key: 'Constipation',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 248,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 24,
    //     value_use: [
    //         'Faecalibacterium prausnitzii',
    //         'Staphylococcus aureus',
    //         'Bifidobacterium lactis',
    //         'Bifidobacterium longum',
    //         'Lactobacillus acidophilus',
    //         'Lactobacillus paracasei',
    //         'Lactobacillus plantarum',
    //         'Lactobacillus rhamnosus'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
    //     ]
    // },
    {
        // Diarrhea page 23
        titel: `Diarrhea`,
        match_key: 'Diarrhea',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 187,
        Xtextpos: 642,
        Ytextpos: 194,
        formula: 'static_asthma_score',
        page: 30,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Roseburia hominis',
            'Bacillus genus',
            'Candida albicans',
            'Clostridium difficile',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Lactobacillus reuteri',
            'Lactobacillus rhamnosus',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Diarrhea page 32
        titel: `Diarrhea`,
        match_key: 'Diarrhea',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 169,
        formula: 'static_asthma_score',
        page: 32,
        value_use: [
            'Faecalibacterium prausnitzii',
            'Roseburia hominis',
            'Bacillus genus',
            'Candida albicans',
            'Clostridium difficile',
            'Escherichia coli',
            'Staphylococcus aureus',
            'Lactobacillus reuteri',
            'Lactobacillus rhamnosus',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Immune disorder page 30
        titel: `Immune disorder`,
        match_key: 'Immune disorder',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 267,
        Xtextpos: 642,
        Ytextpos: 274,
        formula: 'static_asthma_score',
        page: 30,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus helveticus',
            'Lactobacillus paracasei',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Immune disorder page 26
        titel: `Immune disorder`,
        match_key: 'Immune disorder',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 34,
        value_use: [
            'Alistipes putredinis',
            'Roseburia hominis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus helveticus',
            'Lactobacillus paracasei',
            'Streptococcus thermophilus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Insomnia/ poor sleep page 27
        titel: `['Insomnia/ poor', 'sleep quality']`,
        match_key: 'Insomnia/ poor sleep quality',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 1030,
        Xtextpos: 642,
        Ytextpos: 1037,
        formula: 'static_asthma_score',
        page: 36,
        value_use: [
            'Alistipes putredinis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Insomnia/ poor sleep page 27
        titel: `['Insomnia/ poor', 'sleep quality']`,
        match_key: 'Insomnia/ poor sleep quality',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 38,
        value_use: [
            'Alistipes putredinis',
            'Bifidobacterium breve',
            'Bifidobacterium longum',
            'Lactobacillus gasseri',
            'Lactobacillus plantarum',
            'Lactobacillus reuteri'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Stress and anxiety page 27
        titel: `['Stress and', 'anxiety']`,
        match_key: 'Stress and anxiety',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 955,
        Xtextpos: 642,
        Ytextpos: 962,
        formula: 'static_asthma_score',
        page: 36,
        value_use: [
            'Akkermansia muciniphila',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Lactobacillus helveticus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    {
        // Stress and anxiety page 27
        titel: `['Stress and', 'anxiety']`,
        match_key: 'Stress and anxiety',
        width_i: 500,
        height_i: 40,
        Ximagepos: 130,
        Yimagepos: 163,
        Xtextpos: 642,
        Ytextpos: 170,
        formula: 'static_asthma_score',
        page: 37,
        value_use: [
            'Akkermansia muciniphila',
            'Candida albicans',
            'Bifidobacterium bifidum',
            'Lactobacillus helveticus'
          ],
        table_socre: [
            {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
            {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
            {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
        ]
    },
    // {
    //     // Stress and anxiety page 29
    //     titel: `['Stress and', 'anxiety']`,
    //     match_key: 'Stress and anxiety',
    //     Xdotpos: 177,
    //     Ydotpos: 275,
    //     Xnumberpos: 580,
    //     Ynumberpos: 248,
    //     formula: 'static_asthma_score',
    //     max_dot: 10,
    //     page: 29,
    //     value_use: [
    //         'Akkermansia muciniphila',
    //         'Candida albicans',
    //         'Bifidobacterium bifidum',
    //         'Lactobacillus helveticus'
    //       ],
    //     table_socre: [
    //         {min: 0, max: 3, color_dot: '#8bcc2c', label: 'Low'},
    //         {min: 4, max: 6, color_dot: '#fa891f',label: 'Moderate'},
    //         {min: 7, max: 10, color_dot: '#fa1f1f', label: 'High'}
    //     ]
    // }
]
